module.exports = __webpack_public_path__ + "static/media/the-freedom-soup-saving-a-city.6a746138.jpg";